import { render } from "./FilterUpdates.vue?vue&type=template&id=308e4e0d&scoped=true"
import script from "./FilterUpdates.vue?vue&type=script&lang=js"
export * from "./FilterUpdates.vue?vue&type=script&lang=js"

import "./FilterUpdates.vue?vue&type=style&index=0&id=308e4e0d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308e4e0d"]])

export default __exports__